// import { Button } from "@mantine/core";
// import CustomInput from "components/CustomInput/CustomInput";
// import React, { useState } from "react";
// import GridContainer from "components/Grid/GridContainer.js";
// import GridItem from "components/Grid/GridItem.js";
// import axios from "axios";
// import SweetAlert from "react-bootstrap-sweetalert";
// //const baseURL = "https://jsonplaceholder.typicode.com/api/v1/admin/login";
// import stylesData from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
// import { makeStyles } from "@material-ui/core/styles";
// const useStyleData = makeStyles(stylesData);
// import { usenavigate, useParams } from "react-router-dom";

// export default function EditWithdrawal() {
//   const navigate = usenavigate();
//   let { paymentId } = useParams();
//   const [formData, setFormData] = useState({
//     name: "",
//     currency: "",
//     rate: "",
//     minAmount: "",
//     maxAmount: "",
//     fixedCharge: "",
//     percentageCharge: "",
//     userDate: [{ label: "", type: "" }],
//   });
//   const [loading, setLoading] = React.useState(false);
//   const [alert, setAlert] = React.useState(null);

//   const [errors, setErrors] = useState({});

//   const hideAlert = () => {
//     setAlert(null);
//     navigate(`/admin/manageWithdrawalMethods`);
//   };
//         const [showLoader, setShowLoader] = useState(false);
//   React.useEffect(() => {
//     const fetchData = async () => {
//       const token = localStorage.getItem("token");
//       setLoading(true);
//       try {
//         await axios
//           .get(
//             `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/paymentDetail/${paymentId}`,
//             {
//               headers: {
//                 Authorization: `Bearer ${token}`,
//                 "Access-Control-Allow-Origin": "*",
//               },
//             }
//           )
//           .then((res) => {
//             const data = res.data.data;
//             setFormData({
//               name: data?.name,
//               currency: data?.currency,
//               rate: data?.rate,
//               minAmount: data?.minAmount,
//               maxAmount: data?.maxAmount,
//               fixedCharge: data?.fixedCharge,
//               percentageCharge: data?.percentageCharge,
//               userDate: [...data?.userDate],
//             });

//             console.log(data);
//           });
//       } catch (error) {
//         console.error(error.message);
//         if(error?.response?.data?.message=="For security reasons, we locked your account.Please login to continue"){
//           localStorage.removeItem("token");
//           window.location.assign("/auth/login-page");
//         }
//       }
//       setLoading(false);
//     };

//     fetchData();
//   }, []);

//   const handleSubmit = (event) => {
//           console.log("before", showLoader);

//           setShowLoader(true);
  
//     event.preventDefault();
//     const token = localStorage.getItem("token");
//     const validationErrors = validateForm(formData);
//     setErrors(validationErrors);

//     if (Object.keys(validationErrors).length === 0) {
//       // Convert the withdrawal instructions to the desired format
//       const formattedWithdrawInstraction = {};
//       formData.userDate.forEach((instruction, index) => {
//         formattedWithdrawInstraction[`userDate[${index}][label]`] =
//           instruction.label;
//         formattedWithdrawInstraction[`userDate[${index}][type]`] =
//           instruction.type;
//       });

//       // Combine the formatted data with the rest of the form data
//       const finalFormData = {
//         ...formData,
//         withdrawInstraction: formattedWithdrawInstraction,
//       };

//       axios
//         .put(
//           `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/paymentDetail/${paymentId}`,
//           formData,
//           {
//             headers: {
//               Authorization: `Bearer ${token}`,
//               // 'Content-Type': 'application/json',
//               // "Access-Control-Allow-Origin": "*",
//             },
//           }
//         )
//         .then((res) => {
//           setAlert(
//             <SweetAlert
//               style={{ display: "block", marginTop: "-100px" }}
//               title={
//                 <span
//                   style={{
//                     fontSize: "14px",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   {res.data.message}
//                 </span>
//               }
//               onConfirm={() => hideAlert()}
//               onCancel={() => hideAlert()}
//               titleCssClass={classesSweetAlert.cardTitle}
//               confirmBtnCssClass={
//                 classesSweetAlert.button + " " + classesSweetAlert.success
//               }
//             />
//           );
//         })
//         .catch((err) => {
//           console.warn(err);
//           setAlert(
//             <SweetAlert
//               style={{ display: "block", marginTop: "-100px" }}
//               title={
//                 <span
//                   style={{
//                     fontSize: "14px",
//                     fontWeight: "bold",
//                   }}
//                 >
//                   {err}
//                 </span>
//               }
//               onConfirm={() => hideAlert()}
//               onCancel={() => hideAlert()}
//               titleCssClass={classesSweetAlert.cardTitle}
//               confirmBtnCssClass={
//                 classesSweetAlert.button + " " + classesSweetAlert.success
//               }
//             />
//           );
//         });
//       // Send the finalFormData to the server or perform any further actions
//       console.log("Form submitted successfully!", finalFormData);
//     }
//   };
//         console.log("after", showLoader);
//   const validateForm = (data) => {
//     const errors = {};

//     if (data.name.trim() === "") {
//       errors.name = "Name is required";
//     }

//     if (data.currency.trim() === "") {
//       errors.currency = "Currency is required";
//     }

//     if (isNaN(data.rate) || parseFloat(data.rate) <= 0) {
//       errors.rate = "Invalid rate";
//     }

//     if (isNaN(data.minAmount) || parseFloat(data.minAmount) <= 0) {
//       errors.minAmount = "Invalid minimum amount";
//     }

//     if (isNaN(data.maxAmount) || parseFloat(data.maxAmount) <= 0) {
//       errors.maxAmount = "Invalid maximum amount";
//     }

//     if (parseFloat(data.minAmount) > parseFloat(data.maxAmount)) {
//       errors.maxAmount = "Maximum amount must be greater than minimum amount";
//     }

//     if (isNaN(data.fixedCharge) || parseFloat(data.fixedCharge) < 0) {
//       errors.fixedCharge = "Invalid fixed charge";
//     }

//     if (
//       isNaN(data.percentageCharge) ||
//       parseFloat(data.percentageCharge) < 0 ||
//       parseFloat(data.percentageCharge) > 100
//     ) {
//       errors.percentageCharge = "Invalid percentage charge";
//     }

//     return errors;
//   };

//   const handleInputChange = (event) => {
//     const { id, value } = event.target;
//     setFormData({ ...formData, [id]: value });
//     console.log(formData);
//   };

//   const handleInstructionChange = (index, event) => {
//     const { id, value } = event.target;
//     const newInstructions = [...formData.userDate];
//     newInstructions[index] = { ...newInstructions[index], [id]: value };
//     setFormData({ ...formData, userDate: newInstructions });
//   };

//   const addInstruction = () => {
//     setFormData({
//       ...formData,
//       userDate: [...formData.userDate, { label: "", type: "" }],
//     });
//   };

//   const removeInstruction = (index) => {
//     const newInstructions = [...formData.userDate];
//     newInstructions.splice(index, 1);
//     setFormData({ ...formData, userDate: newInstructions });
//   };

//   const classesSweetAlert = useStyleData();
//   return (
//     <>
//       {loading && <div>Loading</div>}
//       {!loading && (
//         <form onSubmit={handleSubmit}>
//           <label htmlFor="name">Name:</label>
//           <CustomInput
//             type="text"
//             id="name"
//             name="name"
//             value={formData.name}
//             handleChange={handleInputChange}
//             inputProps={{
//               type: "text",
//               value: formData.name,
//             }}
//           />
//           {errors.name && <p>{errors.name}</p>}

//           <label htmlFor="currency">Currency:</label>
//           <CustomInput
//             type="text"
//             id="currency"
//             name="currency"
//             value={formData.currency}
//             handleChange={handleInputChange}
//             inputProps={{
//               type: "text",
//               value: formData.currency,
//             }}
//           />
//           {errors.currency && <p>{errors.currency}</p>}

//           <label htmlFor="rate">Rate:</label>
//           <CustomInput
//             type="number"
//             id="rate"
//             name="rate"
//             value={formData.rate}
//             handleChange={handleInputChange}
//             inputProps={{
//               type: "text",
//               value: formData.rate,
//             }}
//           />
//           {errors.rate && <p>{errors.rate}</p>}

//           <label htmlFor="minAmount">Minimum Amount:</label>
//           <CustomInput
//             type="number"
//             id="minAmount"
//             name="minAmount"
//             value={formData.minAmount}
//             handleChange={handleInputChange}
//             inputProps={{
//               type: "text",
//               value: formData.minAmount,
//             }}
//           />
//           {errors.minAmount && <p>{errors.minAmount}</p>}

//           <label htmlFor="maxAmount">Maximum Amount:</label>
//           <CustomInput
//             type="number"
//             id="maxAmount"
//             name="maxAmount"
//             value={formData.maxAmount}
//             handleChange={handleInputChange}
//             inputProps={{
//               type: "number",
//               value: formData.maxAmount,
//             }}
//           />
//           {errors.maxAmount && <p>{errors.maxAmount}</p>}

//           <label htmlFor="fixedCharge">Fixed Charge:</label>
//           <CustomInput
//             type="number"
//             id="fixedCharge"
//             name="fixedCharge"
//             value={formData.fixedCharge}
//             inputProps={{
//               type: "number",
//               value: formData.fixedCharge,
//             }}
//             handleChange={handleInputChange}
//           />
//           {errors.fixedCharge && <p>{errors.fixedCharge}</p>}

//           <label htmlFor="percentageCharge">Percentage Charge:</label>
//           <CustomInput
//             type="number"
//             id="percentageCharge"
//             name="percentageCharge"
//             value={formData.percentageCharge}
//             inputProps={{
//               type: "number",
//               value: formData.percentageCharge,
//             }}
//             handleChange={handleInputChange}
//           />
//           {errors.percentageCharge && <p>{errors.percentageCharge}</p>}

//           {/* <h2>Withdrawal Instructions:</h2> */}
//           {/* <GridContainer container>
//             {formData.userDate.map((instr, index) => (
//               <GridItem
//                 item
//                 xs={4}
//                 key={index}
//                 style={{ marginBottom: "20px" }}
//               >
//                 <label htmlFor="label">Label {index + 1}:</label>
//                 <CustomInput
//                   type="text"
//                   id="label"
//                   name="label"
//                   value={instr.label}
//                   handleChange={(event) =>
//                     handleInstructionChange(index, event)
//                   }
//                   inputProps={{
//                     type: "text",
//                     value: instr.label,
//                   }}
//                 />
//                 <br />

//                 <label htmlFor="type">Type {index + 1}:</label>
//                 <CustomInput
//                   type="text"
//                   id="type"
//                   name="type"
//                   value={instr.type}
//                   handleChange={(event) =>
//                     handleInstructionChange(index, event)
//                   }
//                   inputProps={{
//                     type: "text",
//                     value: instr.type,
//                   }}
//                 />
//                 <br />
//                 {errors[`withdrawalInstruction-${index}`] && (
//                   <p>{errors[`withdrawalInstruction-${index}`]}</p>
//                 )}

//                 <Button type="button" onClick={() => removeInstruction(index)}>
//                   Remove Instruction
//                 </Button>
//               </GridItem>
//             ))}
//           </GridContainer>

//           <Button type="button" onClick={addInstruction}>
//             Add Instruction
//           </Button> */}
//           {alert}
//           {/* Add more label and type fields as needed */}
//           {/* e.g., */}
//           {/* <label htmlFor="label2">Label 2:</label> */}
//           {/* <input type="text" id="label2" name="label2" value={formData.label2} onChange={handleInputChange} /> */}
//           {/* <br /> */}

//           {/* <label htmlFor="type2">Type 2:</label> */}
//           {/* <input type="text" id="type2" name="type2" value={formData.type2} onChange={handleInputChange} /> */}
//           {/* <br /> */}

//           <Button
//             type="submit"
//             loading={showLoader}
//             disabled={showLoader}
//             style={{ marginTop: "20px", display: "flex" }}
//           >
//             Submit
//           </Button>
//         </form>
//       )}
//     </>
//   );
// }




import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import axios from "../../utils/axiosInstance"; 
import SweetAlert from "react-bootstrap-sweetalert";
import { TextField, Button, Grid, Typography, Box } from "@mui/material";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Card from "components/Card/Card";
import CardHeader from "components/Card/CardHeader";
import CardIcon from "components/Card/CardIcon";
import { Assignment } from "@material-ui/icons";
import { makeStyles } from "@material-ui/core";
import styles from "assets/jss/material-dashboard-pro-react/views/validationFormsStyle.js";
const useStyles = makeStyles(styles);
export default function EditWithdrawal() {
  const classes = useStyles();
  const navigate = useNavigate();
  const { paymentId } = useParams();
  const [formData, setFormData] = useState({
    name: "",
    currency: "",
    rate: "",
    minAmount: "",
    maxAmount: "",
    fixedCharge: "",
    percentageCharge: "",
    userDate: [{ label: "", type: "" }],
  });

  console.log(formData , "formData");
  const [loading, setLoading] = useState(false);
  const [alert, setAlert] = useState(null);
  const [errors, setErrors] = useState({});
  const [showLoader, setShowLoader] = useState(false);

  // Hide alert and navigate to withdrawal methods page
  const hideAlert = () => {
    setAlert(null);
    navigate(`/admin/manageWithdrawalMethods`);
  };

  // Fetch data for editing
  useEffect(() => {
    const fetchData = async () => {
      const token = localStorage.getItem("token");
      setLoading(true);
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/paymentDetail/${paymentId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
              "Access-Control-Allow-Origin": "*",
            },
          }
        );
        const data = response.data.data;
        setFormData({
          name: data?.name,
          currency: data?.currency,
          rate: data?.rate,
          minAmount: data?.minAmount,
          maxAmount: data?.maxAmount,
          fixedCharge: data?.fixedCharge,
          percentageCharge: data?.percentageCharge,
          userDate: [...data?.userDate],
        });
      } catch (error) {
        console.error(error.message);
        if (
          error?.response?.data?.message ===
          "For security reasons, we locked your account.Please login to continue"
        ) {
          localStorage.removeItem("token");
          window.location.assign("/auth/login-page");
        }
      }
      setLoading(false);
    };

    fetchData();
  }, [paymentId]);

  // Handle form submission
  const handleSubmit = (event) => {
    event.preventDefault();
    setShowLoader(true);
    const token = localStorage.getItem("token");
    const validationErrors = validateForm(formData);
    setErrors(validationErrors);

    if (Object.keys(validationErrors).length === 0) {
      const formattedWithdrawInstruction = {};
      formData.userDate.forEach((instruction, index) => {
        formattedWithdrawInstruction[`userDate[${index}][label]`] =
          instruction.label;
        formattedWithdrawInstruction[`userDate[${index}][type]`] =
          instruction.type;
      });

      const finalFormData = {
        ...formData,
        withdrawInstruction: formattedWithdrawInstruction,
      };

      axios
        .put(
          `${process.env.REACT_APP_API_URL_PREFIX}/api/v1/admin/paymentDetail/${paymentId}`,
          finalFormData,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((res) => {
          setAlert(
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title={
                <Typography style={{ fontSize: "14px", fontWeight: "bold" }}>
                  {res.data.message}
                </Typography>
              }
              onConfirm={hideAlert}
              onCancel={hideAlert}
            />
          );
        })
        .catch((err) => {
          const errorMessage =
            err.response?.data?.message || "An error occurred. Please try again.";
          setAlert(
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title={
                <Typography style={{ fontSize: "14px", fontWeight: "bold" }}>
                  {errorMessage}
                </Typography>
              }
              onConfirm={hideAlert}
              onCancel={hideAlert}
            />
          );
        });
    }
    setShowLoader(false);
  };

  // Validate form input
  const validateForm = (data) => {
    const errors = {};
    if (!data.name.trim()) errors.name = "Name is required";
    if (!data.currency.trim()) errors.currency = "Currency is required";
    if (isNaN(data.rate) || parseFloat(data.rate) <= 0) errors.rate = "Invalid rate";
    if (isNaN(data.minAmount) || parseFloat(data.minAmount) <= 0)
      errors.minAmount = "Invalid minimum amount";
    if (isNaN(data.maxAmount) || parseFloat(data.maxAmount) <= 0)
      errors.maxAmount = "Invalid maximum amount";
    if (parseFloat(data.minAmount) > parseFloat(data.maxAmount))
      errors.maxAmount = "Maximum amount must be greater than minimum amount";
    if (isNaN(data.fixedCharge) || parseFloat(data.fixedCharge) < 0)
      errors.fixedCharge = "Invalid fixed charge";
    if (
      isNaN(data.percentageCharge) ||
      parseFloat(data.percentageCharge) < 0 ||
      parseFloat(data.percentageCharge) > 100
    )
      errors.percentageCharge = "Invalid percentage charge";
    return errors;
  };

  // Handle input changes
  const handleInputChange = (event) => {
    const { id, value } = event.target;
    setFormData({ ...formData, [id]: value });
  };

  return (

    <>
    <GridContainer>
      <GridItem xs={12}>
        <Card>
          <CardHeader color="rose" icon>
            <CardIcon color="rose">
              <Assignment />
            </CardIcon>
            <h4 className={classes.cardIconTitle}>Edit Withdrawal</h4>
           
          </CardHeader>
    <Box component="form" onSubmit={handleSubmit} sx={{ padding: 4 }}>
      <Typography variant="h5" gutterBottom>
        Edit Withdrawal Method
      </Typography>

      <Grid container spacing={2}>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Name"
            id="name"
            value={formData.name}
            onChange={handleInputChange}
            error={!!errors.name}
            helperText={errors.name}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Currency"
            id="currency"
            value={formData.currency}
            onChange={handleInputChange}
            error={!!errors.currency}
            helperText={errors.currency}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Rate"
            type="number"
            id="rate"
            value={formData.rate}
            onChange={handleInputChange}
            error={!!errors.rate}
            helperText={errors.rate}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Minimum Amount"
            type="number"
            id="minAmount"
            value={formData.minAmount}
            onChange={handleInputChange}
            error={!!errors.minAmount}
            helperText={errors.minAmount}
          />
        </Grid>
        <Grid item xs={12} sm={6}>
          <TextField
            fullWidth
            label="Maximum Amount"
            type="number"
            id="maxAmount"
            value={formData.maxAmount}
            onChange={handleInputChange}
            error={!!errors.maxAmount}
            helperText={errors.maxAmount}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Fixed Charge"
            
            id="fixedCharge"
            value={formData.fixedCharge}
            onChange={handleInputChange}
            error={!!errors.fixedCharge}
            helperText={errors.fixedCharge}
          />
        </Grid>
        <Grid item xs={12}>
          <TextField
            fullWidth
            label="Percentage Charge"
            type="number"
            id="percentageCharge"
            value={formData.percentageCharge}
            onChange={handleInputChange}
            error={!!errors.percentageCharge}
            helperText={errors.percentageCharge}
          />
        </Grid>
        <Grid item xs={12}>
          <Button type="submit" variant="contained" color="primary" fullWidth>
            {showLoader ? "Submitting..." : "Submit"}
          </Button>
        </Grid>
        {alert && <Grid item xs={12}>{alert}</Grid>}
      </Grid>
    </Box>
    </Card>
        </GridItem>
      </GridContainer>
    </>
  );
}
